// ABOUTME: The two summary cards for the relation "nooit verkochte producten" report (Geld / Aantallen &
// ABOUTME: veroudering), written explicitly in an OverflowRow like the warehouse orders TopRow.
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "../../../../components/theme/text/Text";
import OverflowRow from "../../../../components/theme/OverflowRow";
import { tokens } from "../../../../theme";
import { formatPrice, formatNumber } from "../../../../utils/helpers";

// activeFilter: { staleDays } | { noStock:true } | null.  onFilter(next|null) toggles a tile filter.
const NeverSoldCards = ({ totals, isLoading, activeFilter, onFilter }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const d = totals || {};
    const num = (v) => (isLoading ? "" : formatNumber(i18n, v ?? 0));
    const price = (v) => (isLoading ? "" : formatPrice(i18n, v ?? 0));
    const pct = d.catalogTotal ? Math.round(((d.nietVerkocht ?? 0) / d.catalogTotal) * 100) : 0;

    const isStale = (n) => activeFilter?.staleDays === n;

    const cardSx = {
        flex: 1,
        minWidth: 280,
        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
        boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
        p: 1,
        pb: 1.5,
        px: 1.5,
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
    };
    const headerSx = { p: 1, px: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center" };
    const headlineSx = {  fontFamily: "Roboto, sans-serif", fontSize: 21, fontWeight: 1000, color: colors.txt["primary"] };
    const valueSx = {  fontFamily: "Roboto, sans-serif", fontSize: 17, fontWeight: 700, color: colors.txt["primary"], mb: "auto" };

    return (
        <OverflowRow>
            <Box sx={{ 
                    // background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    flex:2,
                    // boxShadow: '0px 1px 2px 1px rgba(49, 65, 95, 0.15)',
                    position:"relative", //Needed for absolutely positioned things
                    // width:1,
                    borderRadius:4,
                    display:"flex",
                    gap:2,
                
            }}>

                {/* ── Aantallen ── */}
                <Box sx={cardSx}>
                    <Box sx={headerSx}>
                        <Text bold>{t("niet_verkocht")}</Text>
                    </Box>
                    <Box sx={{ flex: 1, mt: 1, display: "flex", gap: 1.5 }}>
                        <Box component="button" onClick={() => onFilter(activeFilter?.withStock ? null : { withStock: true })} sx={{
                            flex: 1,
                            border: activeFilter?.withStock ? `2px solid ${theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[200]}` : "none",
                            cursor: "pointer",
                            textAlign: "left",
                            borderRadius: 4,
                            px: 2,
                            py: 1.5,
                            background: activeFilter?.withStock ? theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200] : theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            transition: "150ms",
                            "&:hover": { background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200] },
                        }}>
                            <Typography sx={valueSx}>{num(d.metVoorraad)}</Typography>
                            <Text light semibold>{t("with_stock")}</Text>
                        </Box>
                        <Box sx={{
                                flex: 1,
                            textAlign: "left",
                            borderRadius: 4,
                            px: 2,
                            py: 1.5,
                            background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            transition: "150ms",

                        }}>
                            <Typography sx={valueSx}>{num(d.totaalStuks)}</Typography>
                            <Text light semibold>{t("total_stock")}</Text>
                        </Box>
                    </Box>
                </Box>

                {/* ── Ouder dan 90 dagen ── */}
                <Box sx={cardSx}>
                    <Box sx={headerSx}>
                        <Text bold>{t("ouder_dan_90_dagen")}</Text>
                        <Typography sx={headlineSx}>{num(d.bucket90)}</Typography>
                    </Box>
                    <Box sx={{ flex: 1, mt: 1, display: "flex", gap: 1.5 }}>
                        <Box component="button" onClick={() => onFilter(isStale(90) ? null : { staleDays: 90 })} sx={{
                            flex: 1,
                            border: isStale(90) ? `2px solid ${colors.orange[400]}` : "none",
                            cursor: "pointer",
                            textAlign: "left",
                            borderRadius: 4,
                            px: 2,
                            py: 1.5,
                            background: colors.orange[100],
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            transition: "150ms",
                            "&:hover": { background: colors.orange[200] },
                        }}>
                            <Typography sx={valueSx}>{price(d.waarde90)}</Typography>
                            <Text variant="orange" semibold>{t("voorraadwaarde")}</Text>
                        </Box>
                    </Box>
                </Box>

                {/* ── Ouder dan 180 dagen ── */}
                <Box sx={cardSx}>
                    <Box sx={headerSx}>
                        <Text bold>{t("ouder_dan_180_dagen")}</Text>
                        <Typography sx={headlineSx}>{num(d.bucket180)}</Typography>
                    </Box>
                    <Box sx={{ flex: 1, mt: 1, display: "flex", gap: 1.5 }}>
                        <Box component="button" onClick={() => onFilter(isStale(180) ? null : { staleDays: 180 })} sx={{
                            flex: 1,
                            border: isStale(180) ? `2px solid ${colors.red[400]}` : "none",
                            cursor: "pointer",
                            textAlign: "left",
                            borderRadius: 4,
                            px: 2,
                            py: 1.5,
                            background: colors.red[100],
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            transition: "150ms",
                            "&:hover": { background: colors.red[200] },
                        }}>
                            <Typography sx={valueSx}>{price(d.waarde180)}</Typography>
                            <Text variant="red" semibold>{t("voorraadwaarde")}</Text>
                        </Box>
                    </Box>
                </Box>

                {/* ── Ouder dan 365 dagen ── */}
                <Box sx={cardSx}>
                    <Box sx={headerSx}>
                        <Text bold>{t("ouder_dan_365_dagen")}</Text>
                        <Typography sx={headlineSx}>{num(d.bucket365)}</Typography>
                    </Box>
                    <Box sx={{ flex: 1, mt: 1, display: "flex", gap: 1.5 }}>
                        <Box component="button" onClick={() => onFilter(isStale(365) ? null : { staleDays: 365 })} sx={{
                            flex: 1,
                            border: isStale(365) ? `2px solid ${colors.red[400]}` : "none",
                            cursor: "pointer",
                            textAlign: "left",
                            borderRadius: 4,
                            px: 2,
                            py: 1.5,
                            background: colors.red[100],
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            transition: "150ms",
                            "&:hover": { background: colors.red[200] },
                        }}>
                            <Typography sx={valueSx}>{price(d.waarde365)}</Typography>
                            <Text variant="red" semibold>{t("voorraadwaarde")}</Text>
                        </Box>
                    </Box>
                </Box>

            </Box>
        </OverflowRow>
    );
};

export default NeverSoldCards;
